/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

import React from 'react';
import { permissionObj } from '../../../../../Helpers/permission';
import HeadTittle from '../../../../../components/HeadTittle';
import routes from '../../../../../Routes/routes';
import { CommonContractorCreateUpdateApp } from "../../Functionality/ContractorCreateUpdateFlows/CommonContractorCreateUpdateApp";
import { EmployeeFlowContractorCreateApp } from "../../Functionality/ContractorCreateUpdateFlows/EmployeeFlowContractorCreateApp";
import CopySecretModal from '../../../Company/Employees/Modal/CopySecretModal';
import ContractorCreateStepperWithoutDetails from './ContractorCreateStepperWithoutDetails';
import ContractorCreateStepperWithDetails from './ContractorCreateStepperWithDetails';
import { TABS_CONTRACTORS } from '../../Model/Models';

const EmployeeFlowContractorCreate = () => {

    const props = CommonContractorCreateUpdateApp();

    const {
        t,
        dispatch,
        navigate,
        DEV,
        permission,
        workShiftsList,
        setWorkShiftsList,
        customizedList,
        setCustomizedList,
        isValidEmail,
        isValidPassword, 
        setIsValidPassword,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        isValidDocumentId,
        setIsValidDocumentId,
        userInfoStatusList,
        emptyFields,
        setEmptyFields,
        setIsValidEmail,
        setIsValidPhoneNumber,
        handleDateChange,
        handleEmailChange,
        handlePasswordChange,
        handlePhoneNumberChange,
        validateEmail,
        validatePhone,
        secretModal,
        setSecretModal,
        secretKey,
        setSecretKey,
        generatedPassword,
        setGeneratedPassword,
        passwordGenerator,
        disabled,
        activeStep,
        setActiveStep,
        steps,
        setSteps,
        handleStepChange,
        photoPicker,
        setPhotoPicker,
        extraData,
        setExtraData,
        headersList,
        extraDataEnabled,
        setExtraDataEnabled,
    } = props;

    const {
        user,
        setUser,
        FormHandler,
        resetForm,
        getAllServiceType,
        handleValidateSteps,
        handleOnBack,
        handleChange,
        handleClearExtraData,
    } = EmployeeFlowContractorCreateApp({
        t,
        dispatch,
        navigate,
        workShiftsList,
        customizedList,
        setEmptyFields,
        setIsValidEmail,
        isValidPassword,
        setIsValidPassword,
        setIsValidPhoneNumber,
        isValidDob,
        photoPicker,
        setPhotoPicker,
        permission,
        setWorkShiftsList,
        setCustomizedList,
        setSecretModal,
        setSecretKey,
        setGeneratedPassword,
        passwordGenerator,
        setSteps,
        setIsValidDocumentId,
        isValidDocumentId,
        setExtraData,
        headersList, 
        extraData,
        extraDataEnabled,
        setExtraDataEnabled
    });


    if (!DEV && (!permission?.includes(permissionObj.WEB_CONTRACTOR_READ) ||
        !permission?.includes(permissionObj.WEB_CONTRACTOR_CREATE))) navigate(routes.forbidden);

    return (
        <>
            <HeadTittle
                onBack={handleOnBack}
                name={t("create")}
            />
              {extraDataEnabled ? (
            <ContractorCreateStepperWithDetails
                user={user}
                setUser={setUser}
                steps={steps}
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
                emptyFields={emptyFields}
                resetForm={resetForm}
                getAllServiceType={getAllServiceType}
                handleValidateSteps={handleValidateSteps}
                extraData={extraData}
                setExtraData={setExtraData}
                headersList={headersList}
                handleChange={handleChange}
                handleClearExtraData={handleClearExtraData}
                isValidDocumentId={isValidDocumentId}
                setIsValidDocumentId={setIsValidDocumentId}
                isValidEmail={isValidEmail}
                isValidPhoneNumber={isValidPhoneNumber}
                isValidDob={isValidDob}
                setIsValidDob={setIsValidDob}
                handleEmailChange={handleEmailChange}
                handlePasswordChange={handlePasswordChange}
                handlePhoneNumberChange={handlePhoneNumberChange}
                handleDateChange={handleDateChange}
                userInfoStatusList={userInfoStatusList}
                photoPicker={photoPicker}
                setPhotoPicker={setPhotoPicker}
                disabled={disabled}
                workShiftsList={workShiftsList}
                setWorkShiftsList={setWorkShiftsList}
                customizedList={customizedList}
                setCustomizedList={setCustomizedList}
                validateEmail={validateEmail}
                validatePhone={validatePhone}
                FormHandler={FormHandler}
            />
        ) : (
            <ContractorCreateStepperWithoutDetails
                user={user}
                setUser={setUser}
                steps={steps}
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
                emptyFields={emptyFields}
                resetForm={resetForm}
                getAllServiceType={getAllServiceType}
                handleValidateSteps={handleValidateSteps}
                isValidDocumentId={isValidDocumentId}
                setIsValidDocumentId={setIsValidDocumentId}
                isValidEmail={isValidEmail}
                isValidPhoneNumber={isValidPhoneNumber}
                isValidDob={isValidDob}
                setIsValidDob={setIsValidDob}
                handleEmailChange={handleEmailChange}
                handlePasswordChange={handlePasswordChange}
                handlePhoneNumberChange={handlePhoneNumberChange}
                handleDateChange={handleDateChange}
                userInfoStatusList={userInfoStatusList}
                photoPicker={photoPicker}
                setPhotoPicker={setPhotoPicker}
                disabled={disabled}
                workShiftsList={workShiftsList}
                setWorkShiftsList={setWorkShiftsList}
                customizedList={customizedList}
                setCustomizedList={setCustomizedList}
                validateEmail={validateEmail}
                validatePhone={validatePhone}
                FormHandler={FormHandler}
                extraDataEnabled={extraDataEnabled}
                headersList={headersList}
                extraData={extraData}
            />
        )}
            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUser}
                generatedPassword={generatedPassword}
                onHide={() => {
                    navigate(routes.contractor.list, {
                        state: {currentTab:TABS_CONTRACTORS.CONTRACTORS.INDEX}
                    });
                }}
                closeText={'continue'}
            />

        </>
    );
};

export default EmployeeFlowContractorCreate;
